import {
    getGroupAlertColor,
    getGroupAlertTooltip,
    handleMatchAlertEvent,
    hasGroupAlert
} from "@/services/matchAlerts";

// Индикация активных алертов прямо на карточках матчей сетки:
// состояние держит @/services/matchAlerts, миксин только прокидывает его в шаблон.
export const MatchAlertsMixin = {
    methods: {
        // Возвращает true, если сообщение было событием алерта — тогда
        // обработчик сокета в сетке может больше ничего с ним не делать.
        handleMatchAlertMessage(message) {
            return handleMatchAlertEvent(message)
        },
        hasMatchAlert(groupId) {
            return hasGroupAlert(groupId)
        },
        matchAlertColor(groupId) {
            return getGroupAlertColor(groupId)
        },
        matchAlertTooltip(groupId) {
            return getGroupAlertTooltip(groupId)
        }
    }
}
